export default "__VITE_ASSET__C$DkmrCw__"